import React from 'react'
// import { AiFillAppstore } from "react-icons/ai";
import { FaDumbbell, FaChild} from "react-icons/fa";
import { GiSwitchWeapon, GiWeight, GiKimono } from "react-icons/gi";
import { IoFitness } from "react-icons/io5";
import Title from '../layouts/Title';
import Card from './Card';

const Programs = () => {
  return (
    <section
      id="features"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <Title title="Programs" des="Our Programs" />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-20">
        <Card
          title="Self-Defence"
          des="Self-defense in karate involves learning techniques to protect oneself from physical harm. 
          Emphasizing situational awareness and effective counterattacks, self-defense training equips practitioners 
          with the skills and confidence needed to respond to potential threats, ensuring personal safety."
          icon={<FaDumbbell />}
        />
        <Card
          title="Weapons training"
          des="Weapons training in karate includes the study of traditional martial arts weapons such as 
          bo staff, nunchaku, and sai. Practitioners develop precision, coordination, 
          and discipline in handling these weapons, enhancing their overall martial arts proficiency."
          icon={<GiSwitchWeapon />}
        />
        <Card
          title="Weight lose"
          des="Karate is an excellent form of exercise for weight loss. The dynamic movements, cardiovascular 
          benefits, and muscle engagement contribute to burning calories and improving overall fitness. 
          Regular karate practice, 
          combined with a healthy lifestyle, can aid in weight management and achieving fitness goals."
          icon={<><GiWeight /></>}
        />
        <Card
          title="Body fitness"
          des="Karate is a holistic fitness activity that engages the entire body. From punches and kicks that 
          work the upper and lower body to stances and movements that enhance flexibility and balance, 
          karate contributes to overall physical fitness. 
          It promotes strength, agility, and endurance, fostering a well-rounded approach to health."
          icon={<IoFitness />}
        />
        <Card
          title="Kids Karate"
          des="Kids karate programs focus on developing fundamental motor skills, discipline, and 
          respect in a fun and supportive environment. Through age-appropriate activities and games, 
          children learn basic karate techniques, build confidence, and develop essential life skills 
          such as teamwork and concentration."
          icon={<FaChild />}
        />
        <Card
          title="Ladies Self-Defence"
          des="Ladies self-defense classes offer specialized training tailored to the unique needs and 
          concerns of women. These classes emphasize practical techniques to escape potential threats, 
          enhance situational awareness, and build self-confidence. 
          Empowering women with self-defense skills contributes to personal safety and well-being."
          icon={<GiKimono />}
        />

      </div>
    </section>
  );
}

export default Programs